import { createAction } from '@mews/framework';
import { PurchaseOrderNumber } from '@mews-commander/data-access';
import { ApplicationState } from '@mews-commander/types';
import prefix from '../prefix';
import parentSelector from '../selector';
import { createBaseEntitySelectors, createEntitiesReducer } from './utils';

export const NAME = 'reservationPurchaseOrderNumber';

const RESERVATION_PURCHASE_ORDER_NUMBERS_LOADED = prefix('RESERVATION_PURCHASE_ORDER_NUMBERS_LOADED');
const RESERVATION_PURCHASE_ORDER_NUMBERS_RESET = prefix('RESERVATION_PURCHASE_ORDER_NUMBERS_RESET');

export const setReservationPurchaseOrderNumbers = (reservationPurchaseOrderNumbers: PurchaseOrderNumber[]) =>
    createAction(RESERVATION_PURCHASE_ORDER_NUMBERS_LOADED, { entities: reservationPurchaseOrderNumbers });

export const resetReservationPurchaseOrderNumbers = () => createAction(RESERVATION_PURCHASE_ORDER_NUMBERS_RESET);

export const reservationPurchaseOrderNumberReducer = createEntitiesReducer({
    FETCH_SUCCESS: RESERVATION_PURCHASE_ORDER_NUMBERS_LOADED,
    RESET_SUCCESS: RESERVATION_PURCHASE_ORDER_NUMBERS_RESET,
});

export const [
    getReservationPurchaseOrderNumbers,
    getReservationPurchaseOrderNumberByIds,
    getReservationPurchaseOrderNumberByOwnerId,
    getReservationPurchaseOrderNumber,
] = createBaseEntitySelectors<ApplicationState, PurchaseOrderNumber, typeof NAME>(parentSelector, NAME);
